import { ReactNode, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAuth } from '@/contexts/AuthContext';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { isDemo } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      {isDemo && (
        <div className="bg-amber-400 text-amber-900 text-center text-sm font-medium py-2 px-4 z-50 sticky top-0">
          👁 Demo mode — breytingar eru ekki vistaðar
        </div>
      )}

      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      <div className={`lg:pl-64 ${isDemo ? 'pt-0' : ''}`}>
        <Header onMenuClick={() => setIsSidebarOpen(true)} />

        <main className="p-4 lg:p-6 animate-fade-in">
          {children}
        </main>
      </div>
    </div>
  );
}
